module.exports = __webpack_public_path__ + "img/logo-transparente.126c50ad.svg";